import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetTipos_concedentes", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var tipos_concedentes = {
    data: [],
    meta: {}
  };

  await services.tipos_concedentes.get_all(search).then(res => {
    tipos_concedentes = res.data;
  });
  return tipos_concedentes;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.tipos_concedentes.show({ id: id }).then(res => {
    dispatch("ActionSetTipo_concedente", res.data.tipo_concedente);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.tipos_concedentes.store(payload).then(res => {
    commit(types.SET_TIPO_CONCEDENTE, res.data.tipo_concedente);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.tipos_concedentes
    .update({ id: payload.id }, payload)
    .then(res => {
      commit(types.SET_TIPO_CONCEDENTE, res.data.tipo_concedente);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.tipos_concedentes.delete({ id: id }).then(() => {
    commit(types.SET_TIPO_CONCEDENTE, null);
  });
};

export const ActionSetTipos_concedentes = ({ commit }, payload) => {
  commit(types.SET_TIPOS_CONCEDENTES, payload);
};

export const ActionSetTipo_concedente = ({ commit }, payload) => {
  commit(types.SET_TIPO_CONCEDENTE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewTipoConcedente = ({ commit }) => {
  let tipo_concedente = {
    nome: "",
    descricao: ""
  };
  commit(types.SET_TIPO_CONCEDENTE, tipo_concedente);
};
